import axios from 'axios'

export const shopAxios = axios.create({
    baseURL: process.env.REACT_APP_API_BASE
})